/* 
	https://support.maestrooo.com/article/764-javascript-events-exposed-by-the-theme 
*/

/* 
	We define an object with key and value.
	Key = variant title (example: "discovery", "non-alcoholic")
	Value = description linked to these keys

	When a variant is triggered, check our object for a match. 
	If we have a match, write the value into a div. 
*/

const mr_damis_styles_dictionary = {
	"Easy Drinking": "Wine you don't have to think about. Handpicked by our amis so the lineup looks (and tastes) like you knew exactly what you were doing.",
	"Discovery": "Adventurous bottles from makers who don't play it safe. A little rough around the edges, never dull, always alive.",
	"Classics": "The safe bet that's actually a great bet. Familiar regions, serious producers, wines that show what a place is supposed to taste like.",
	"Non-alcoholic": "Sophisticated, alcohol-free, and genuinely good. Not drinking doesn't mean missing out."
};
let currentVariant;

function MrDamisShowVariantDescription(variant,previousVariant) {
	
	if (!variant || !variant.option1){
		// There is no valid variant object
		// Show the last selected variant instead.

		if (currentVariant == previousVariant) {
			
			document.querySelector('.mr-damis--subscription-styles-description--container').textContent = mr_damis_styles_dictionary[previousVariant.option1];

			// update global
			currentVariant = previousVariant;
			
		} else {
			
			// set label to currentVariant
			document.querySelector('.mr-damis--subscription-styles-description--container').textContent = mr_damis_styles_dictionary[currentVariant.option1];
		}
		
	} else {

		// There is a valid variant object 
		if (mr_damis_styles_dictionary.hasOwnProperty(variant.option1)) {
			
			/*
			The element .mr-damis--subscription-styles-description--container is hard-coded on 
			the product definition in the admin https://admin.shopify.com/store/club-damis/themes/188005974358/editor?previewPath=%2Fproducts%2Fyour-personal-bottle-subscription&block=template--29270532161878__main__liquid_yfrck3&section=template--29270532161878__main
			*/
			//console.log("match: " + mr_damis_styles_dictionary[variant.option1]);
			document.querySelector('.mr-damis--subscription-styles-description--container').textContent = mr_damis_styles_dictionary[variant.option1];

			// update global
			currentVariant = variant;
		
		} else {
			//console.log("no match");
		}

	}
}

document.addEventListener('variant:change', function(event) {
	let variant = event.detail.variant; // Gives you access to the whole variant details
	let previousVariant = event.detail.previousVariant; // Gives you access to the details of the previously selected variant
	let form = event.target; // The form that triggers the change

	MrDamisShowVariantDescription(variant,previousVariant);

});

// On page load — check the active variant
document.addEventListener('DOMContentLoaded', function() {
	
	MrDamisShowVariantDescription(MrDamisInitialVariant,null);
	
});